import React, { createContext, useContext, useEffect, useState } from "react";
import SSRStorage from "./SSRStorage";

const ThemeContext = createContext(null as any);

export const ThemeProvider = ({ children }) => {
    let loadTheme = SSRStorage.getItem("theme") === "dark" ? "dark" : "light";
    const [theme, setTheme] = useState(loadTheme);

    useEffect(() => {
        const root = window.document.documentElement;
        root.classList.remove("dark", "light");
        root.classList.add(theme);
        SSRStorage.setItem("theme", theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
